import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ProductInOutput (props){

    return <BasicCrudScreenType id ="ProductInOutput" table ="ProductInOutput" view ="VwProductInOutput" noCreate noDelete noExcel noEdit />
}

export default ProductInOutput;